// extracted by mini-css-extract-plugin
export default {"wrapper":"h5_wrapper__-qwcV","box":"h5_box__-ZOqX","title":"h5_title__qOqVw","title2":"h5_title2__A+qOl"};